/* eslint-disable */
export const ar = {
    'QR код': 'رمز الاستجابة السريعة',
    Бейдж: 'شارة',
    'Виджет с картой': 'أداة تشمل خريطة',
    Кнопка: '‫زِر‬',
    Ссылка: 'رابط',
    'widgetgenerator.erip.tooltip':
        "إنه كود خاص يتم إنشاؤه وتعيينه لكل إعلان يتم نشره عبر الإنترنت. هذا الكود عام، مما يعني أنه متاح لجميع المستخدمين على الويب، ومضمّن في معلمات الرابط. يمكنك العثور على رمز ERID المميز في <a href='https://distribution.yandex.ru/v2/create/partner/go?utm_source=widget_generator'>حساب</a> Yandex Distribution",
    'widgetgenerator.legal.url.yandex': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.legal.url.yango': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.modal.continue': 'المتابعة',
    'widgetgenerator.modal.message':
        'نوع الأداة "أداة تشمل خريطة" غير مدعوم لهذا العنوان، يُرجى استخدام تنسيق أداة مختلف',
    'widgetgenerator.yandex.badge.orderInYandex': 'طلب رحلة مع Yandex go',
    'widgetgenerator.yandex.defaultAddress': 'موسكو، الاتحاد الروسي، 16 شارع لفا تولستوغو.',
    'widgetgenerator.yango.badge.getRidetitle': 'طلب رحلة',
    'widgetgenerator.yango.badge.orderInYango': 'طلب رحلة مع Yango',
    'widgetgenerator.yango.defaultAddress': 'ديرة، دبي، الإمارات العربية المتحدة، مطار دبي الدولي',
    Адрес: 'العنوان',
    'Адрес сайта или CLID партнерской программы': 'عنوان الموقع أو برنامج الشريك CLID',
    'Без адреса': 'لا يوجد عنوان',
    Бизнес: 'الأعمال',
    'Введите авторизационные данные для доступа к API. Получить их можно':
        'أدخل بيانات الاعتماد للوصول إلى واجهة برمجة التطبيقات (API). يمكنك الحصول عليها',
    'Вызвать такси': 'طلب رحلة',
    'Генератор виджета': 'مُنشئ الأداة',
    'Доехать на такси': 'الحصول على رحلة',
    Заголовок: 'العنوان',
    Загрузить: 'تحميل',
    Комфорт: 'الراحة',
    Копировать: 'نسخ',
    Куда: 'إلى',
    'Маршрут, встроенный в ссылку': 'المسار مضمّن في الرابط',
    Минивен: 'ميني فان',
    'Нажимая «Получить код» вы соглашаетесь с': 'بالضغط على "الحصول على كود"، فإنك توافق على قبول',
    'Невозможно выбрать тариф: регион не поддерживается':
        'فئة الخدمة غير متاحة: المنطقة غير مدعومة',
    'Неправильный адрес': 'عنوان غير صالح',
    'Новый виджет': 'أداة جديدة',
    Откуда: 'من',
    Подзаголовок: 'العنوان الفرعي',
    'Получить код': 'الحصول على كود',
    'Скачать QR код': 'تنزيل رمز الاستجابة السريعة',
    'Скопируйте код и установите на сайте': 'انسخ الكود وأضفه إلى موقعك',
    Стиль: 'الشكل',
    Стоимость: '‫السعر',
    Тариф: 'فئة الخدمة',
    'Текст успешно скопирован': '‫تم نسخ النص‬',
    'Указанный адрес': 'العنوان الذي تم إدخاله',
    'Фоновое изображение': 'صورة الخلفية',
    Цена: 'السعر',
    Эконом: 'وفِّر',
    'Это поле обязательно': 'حقل مطلوب',
    'оставив заявку': 'عن طريق تقديم طلب',
    'условиями использования': 'شروط الاستخدام',
};
